
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/2022/races/embed/overseas-absentee-voting-results/vice-president",
      function () {
        return require("private-next-pages/elections/2022/races/embed/overseas-absentee-voting-results/vice-president.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/2022/races/embed/overseas-absentee-voting-results/vice-president"])
      });
    }
  